import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import {CustomerDetailsModel} from "../../shared/models/customers/customer.model";
import {ApiService} from "../../core/api/api.service";
import {AccessControlService} from "../../core/access-control/access-control.service";
import {customerRole} from "../../core/access-roles/customer.role";

@Component({
    selector: 'bergh-search-sort',
    templateUrl: './search-sort.component.html',
    styleUrls: ['./search-sort.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SearchSortComponent implements OnInit {
  view: boolean = true;
  @Output() toggle: EventEmitter<boolean> = new EventEmitter();
  @Output() searchData: EventEmitter<any> = new EventEmitter();
  @Output() filterSeals: EventEmitter<boolean> = new EventEmitter();
  @Output() filterProjects: EventEmitter<boolean> = new EventEmitter();
  @Input() type: string;
  sort = 'Naam A-Z';
  search = '';
  show = false;
  searchPlaceholder = '';
  sortList = [];
  loading: boolean = false;
  showFilter: boolean = true;
  public customers: any;
  valueChanged: Subject<any> = new Subject();
  value: any;
  public customerId = '';
  public paginationObj = {
    search: '',
    sortField: 'name',
    sortOrder: 'asc',
    itemPerPage: '',
    pageNumber: 1,
    activeState: 'active',
  };
  constructor(
    private _api: ApiService,
    private _accessControl: AccessControlService
  ) {}

  ngOnInit(): void {
    if (this._accessControl.getRoleCode() === customerRole.code) {
      this.showFilter = false;
    } else {
      this.getAllCustomers();
    }
    this.type === 'SEALS' ? (this.sort = 'Code A-Z') : (this.sort = 'Naam A-Z');
    if (this.type === 'Employee') {
      this.sortList = ['Naam Z-A', 'Gebruikersnaam A-Z', 'Gebruikersnaam Z-A'];
      this.searchPlaceholder = 'Zoek werknemer op gebruikersnaam';
      this.show = true;
    } else if (this.type === 'Customer') {
      this.sortList = ['Naam Z-A', 'Adres A-Z', 'Adres Z-A'];
      this.searchPlaceholder = 'Zoek klant';
      this.show = true;
    } else if (this.type === 'SEALS') {
      this.sortList = ['Code Z-A'];
      this.searchPlaceholder = 'Zoek op code, QR';
      this.show = true;
    } else {
      this.sortList = [
        'Naam Z-A',
        'Projectnummer 0-9',
        'Projectnummer 9-0',
        'Adres A-Z',
        'Adres Z-A',
        'Notities A-Z',
        'Notities Z-A',
      ];
      this.searchPlaceholder = 'Zoek projecten';
      this.show = false;
    }
    if (localStorage.getItem('data') !== null) {
      const data = JSON.parse(localStorage.getItem('data'));
      this.customerId = data.customerId;
      this.search = data.search;
      this.sort = data.sort;
      this.searchUser();
    }
    this.onLoadViewSet();
  }

  /**
   * This function handles the view switch between list view and grid view
   *
   * @returns void
   */
  toggleSwitch(): void {
    this.view = !this.view;
    localStorage.setItem('view', this.view.toString());
    this.toggle.emit(this.view);
  }

  /**
   * On initilization of the component this checks the state of the view
   *
   * @returns void
   */
  onLoadViewSet(): void {
    if (localStorage.getItem('view')) {
      this.view = localStorage.getItem('view') === 'true';
    }
    this.toggle.emit(this.view);
  }

  public searchUser(search?) {
    this.search = search !== undefined ? search : this.search;
    const filterQuery = {
      search: this.search,
      customerId: this.customerId,
      sort: this.sort
    }
    localStorage.removeItem('data');
    localStorage.setItem('data', JSON.stringify(filterQuery));
    const TYPE =
      this.sort === 'Naam A-Z' || this.sort === 'Naam Z-A'
        ? 'name'
        : this.sort === 'Gebruikersnaam A-Z' ||
          this.sort === 'Gebruikersnaam Z-A'
        ? 'username'
        : this.sort === 'Adres A-Z' || this.sort === 'Adres Z-A'
        ? 'address'
        : this.sort === 'Projectnummer 0-9' || this.sort === 'Projectnummer 9-0'
        ? 'number'
        : this.sort === 'Notities A-Z' || this.sort === 'Notities Z-A'
        ? 'extras'
        : this.sort === 'Code A-Z' || this.sort === 'Code Z-A'
        ? 'code'
        : this.sort === 'Status G-V' || this.sort === 'Status V-G'
        ? '_statusId'
        : '';
    const SORT =
      this.sort === 'Naam A-Z' ||
      this.sort === 'Gebruikersnaam A-Z' ||
      this.sort === 'Adres A-Z' ||
      this.sort === 'Projectnummer 0-9' ||
      this.sort === 'Notities A-Z' ||
      this.sort === 'Code A-Z' ||
      this.sort === 'Status G-V'
        ? 'asc'
        : 'desc';
    if (this.customerId === '') {
      this.value = {
        sort: SORT,
        search: this.search,
        type: TYPE,
      };
    } else {
      this.value = {
        sort: SORT,
        search: this.search,
        type: TYPE,
        custId: this.customerId,
      };
    }
    if (this.valueChanged.observers.length === 0) {
      this.valueChanged
        .pipe(debounceTime(1000), distinctUntilChanged())
        .subscribe((filterQuery) => {
          this.searchData.emit(filterQuery);
        });
    }
    this.valueChanged.next(this.value);
  }

  getAllCustomers(): void {
    this.loading = true;
    let pathParam =
      '?search=' +
      this.paginationObj.search +
      '&' +
      'sortField=' +
      this.paginationObj.sortField +
      '&' +
      'sortOrder=' +
      this.paginationObj.sortOrder +
      '&' +
      'itemPerPage=' +
      this.paginationObj.itemPerPage +
      '&pageNumber=' +
      this.paginationObj.pageNumber +
      '&activeState=' +
      this.paginationObj.activeState;
    this._api
      .request('getAllCustomer', '', pathParam)
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(
        (result: CustomerDetailsModel) => {
          this.customers = result.customers;
          this.loading = false;
          if (localStorage.getItem('CUST_ID')) {
            this.customerId = localStorage.getItem('CUST_ID');
            this.searchUser();
            localStorage.removeItem('CUST_ID');
          }
        },
        (error: any) => {
          console.error(error)
          this.loading = false
        }
      );
  }
}
